import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const tableOfContents = [
  "Information We Collect",
  "Consent",
  "Disclosure",
  "Payment",
  "ThirdParty Services",
  "Security",
  "Cookies",
  "Age of Consent",
  "Changes to This Privacy Policy",
  "Contact Information",
];

export default function PrivacyPolicy() {
  return (
    <div className="w-full font-inter bg-gray-100 min-h-screen">
      <Navbar />

      <div className="px-4 sm:px-8 md:px-20   pt-12 pb-20">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="w-full lg:w-1/3">
            <div className="bg-white rounded-[20px] p-6 lg:px-10 lg:py-8 shadow-sm h-fit sticky top-6">
              <p className="text-xl font-semibold text-[#007bff] mb-4">
                Table of Content
              </p>
              <ul className="space-y-1 text-text-secondary list-disc list-inside">
                {tableOfContents.map((item, index) => (
                  <li
                    key={index}
                    className="hover:text-[#007bff] cursor-pointer transition-colors"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="w-full lg:w-2/3">
            <div className="bg-white rounded-[20px] pb-12 shadow-sm">
              <div className="text-2xl md:text-3xl font-medium py-6 px-6 lg:px-12 text-slate-800 border-b border-slate-100">
                Privacy Policy
              </div>

              <div className="px-6 lg:px-12 pt-8 space-y-6 text-text-secondary leading-relaxed">
                <p>
                  Isancharr (“we,” “our,” or “us”) values your privacy and is
                  committed to safeguarding your personal information. This
                  Privacy Policy, effective from August, 2024, explains how we
                  collect, use, and disclose information when you visit or make
                  a purchase from Isancharr.com, which is now operated by
                  Isancharr.
                </p>

                <div>
                  <p className="text-lg font-semibold text-heading-blue mb-2">
                    Information We Collect
                  </p>
                  <p>
                    When you purchase a product from our store, we collect
                    personal information that you provide, such as your name,
                    address, and email address, as part of the buying and
                    selling process. Additionally, when you browse our website,
                    we automatically receive your computer’s internet protocol
                    (IP) address, which helps us learn about your browser and
                    operating system.
                  </p>
                </div>

                <div>
                  <p className="text-lg font-semibold text-heading-blue mb-2">
                    Consent
                  </p>
                  <div className="space-y-4">
                    <p>
                      <strong>How do we obtain your consent?</strong>
                    </p>
                    <p>
                      When you provide us with personal information to complete
                      a transaction, verify your credit card, place an order,
                      arrange a delivery, or return a purchase, you consent to
                      our collecting and using it for that specific purpose
                      only.
                    </p>
                    <p>
                      If we request your personal information for a secondary
                      purpose, such as marketing, we will either ask you
                      directly for your explicit consent or provide you with an
                      opportunity to decline.
                    </p>
                    <p>
                      <strong>How do I withdraw my consent?</strong>
                    </p>
                    <p>
                      If, after opting in, you change your mind, you may
                      withdraw your consent for us to contact you at any time by
                      contacting us at
                      <span className="text-heading-blue ml-1">
                        support@Isancharr.com
                      </span>
                      .
                    </p>
                  </div>
                </div>

                <div>
                  <p className="text-lg font-semibold text-heading-blue mb-2">
                    Disclosure
                  </p>
                  <p>
                    We may disclose your personal information if required by law
                    or if you violate our Terms of Service.
                  </p>
                </div>

                <div>
                  <p className="text-lg font-semibold text-heading-blue mb-2">
                    Payment
                  </p>
                  <p className="mb-4">
                    We use the Razorpay Payment Gateway to process payments.
                    Razorpay does not store your card data on its servers. Your
                    payment information is encrypted through the Payment Card
                    Industry Data Security Standard (PCIDSS) during processing.
                  </p>
                  <p>
                    Our payment gateway adheres to the standards set by PCIDSS.
                    For more details, please refer to Razorpay's terms at
                    <a
                      href="https://razorpay.com"
                      target="_blank"
                      rel="noreferrer"
                      className="text-heading-blue hover:underline ml-1"
                    >
                      https://razorpay.com
                    </a>
                    .
                  </p>
                </div>

                <div>
                  <p className="text-lg font-semibold text-heading-blue mb-2">
                    ThirdParty Services
                  </p>
                  <p>
                    Generally, thirdparty providers we use will only collect,
                    use, and disclose your information to the extent necessary
                    to perform the services they provide to us. Once you leave
                    our website, this Privacy Policy no longer applies.
                  </p>
                </div>

                <div>
                  <p className="text-lg font-semibold text-[#007bff] mb-2">
                    Security
                  </p>
                  <p>
                    To protect your personal information, we take reasonable
                    precautions and follow industry best practices to ensure
                    that it is not inappropriately lost, misused, accessed,
                    disclosed, altered, or destroyed.
                  </p>
                </div>

                <div>
                  <p className="text-lg font-semibold text-[#007bff] mb-2">
                    Contact Information
                  </p>
                  <p>
                    If you would like to access, correct, amend, or delete any
                    personal information we have about you, contact our Privacy
                    Compliance Officer at:
                    <a
                      href="mailto:support@Isancharr.com"
                      className="text-[#007bff] font-medium hover:underline ml-1"
                    >
                      support@Isancharr.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
